export default __webpack_public_path__ + "static/media/FSMeridian-Regular.187cd642.woff2";